/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_CLEAR_GRAPH,
  SET_HSN_LIST,
  SET_GST_LIST,
  SET_RET_PERIOD,
  SET_VAULE_BY_TOP_HSN,
  SET_HSN_VAULE_QTR,
  SET_ITC_REVERSAL,
  SET_ITC_RECO_ANALYSIS,
  SET_ITC_RECO_ANALYSIS_AGG,
  SET_ITC_RECO_VENDOR_AGG
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  GstListData: [],
  HsnListData: [],
  ReturnPeriodData: [],
  ValueByTopHsnData: [],
  hsnValueQtrData: [],
  itcRecoAnalysisData: [],
  itcRecoAnalysisAggData: [],
  itcRecoVendorViseData: [],
  itcReversalData: []
};

/* eslint-disable default-case, no-param-reassign */
const ITCAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_GST_LIST:
      return {
        ...state,
        GstListData: action.GstListData
      };
    case SET_HSN_LIST:
      return {
        ...state,
        HsnListData: action.HsnListData
      };
    case SET_RET_PERIOD:
      return {
        ...state,
        ReturnPeriodData: action.ReturnPeriodData
      };
    case SET_VAULE_BY_TOP_HSN:
      return {
        ...state,
        ValueByTopHsnData: action.ValueByTopHsnData
      };
    case SET_HSN_VAULE_QTR:
      return {
        ...state,
        hsnValueQtrData: action.hsnValueQtrData
      };
    case SET_ITC_RECO_ANALYSIS:
      return {
        ...state,
        itcRecoAnalysisData: action.itcRecoAnalysisData
      };
    case SET_ITC_RECO_ANALYSIS_AGG:
      return {
        ...state,
        itcRecoAnalysisAggData: action.itcRecoAnalysisAggData
      };
    case SET_ITC_RECO_VENDOR_AGG:
      return {
        ...state,
        itcRecoVendorViseData: action.itcRecoVendorViseData
      };
    case SET_ITC_REVERSAL:
      return {
        ...state,
        itcReversalData: action.itcReversalData
      };

    case SET_CLEAR_GRAPH:
      return {
        ...state,
        hsnValueQtrData: [],
        ValueByTopHsnData: [],
        ReturnPeriodData: [],
        HsnListData: [],
        GstListData: [],
        itcRecoAnalysisData:[],
        itcRecoAnalysisAggData:[],
        itcRecoVendorViseData:[],
        itcReversalData:[]
      };
    default:
      return state;
  }
};

export default ITCAnalysisReducer;
